import {HTTP_CODES} from '@stubhub/general-utils';

const INVALID_ERROR_CODE_START = 'catalog.read.INVALID_';

/**
 * Returns true if the error status is 404 or it's 400 and the error code matches `catalog.read.INVALID_` error code. For example `catalog.read.INVALID_CATEGORY_ID`.
 * @param {object} error The error object from the entity request
 * @returns {boolean} true if the error matches the not found criteria, false otherwise
 */
export const isNotFoundEntity = (error) => {
  const {status: errorStatus, body: {code: errorCode} = {}} = error || {};

  return (
    errorStatus === HTTP_CODES.RESOURCE_NOT_FOUND ||
    (errorStatus === HTTP_CODES.BAD_REQUEST && errorCode.includes(INVALID_ERROR_CODE_START))
  );
};
